import { Crown, MapPin, Gem, MessageCircle, Globe2, Sparkles } from "lucide-react";
import { useI18n } from "@/lib/i18n";

const ICONS = [Crown, MapPin, Gem, MessageCircle, Globe2, Sparkles];

export default function WhyChoose() {
    const { t } = useI18n();
    const pillars = t("why.pillars") || [];
    return (
        <section
            id="why"
            data-testid="why-section"
            className="relative py-28 md:py-40 bg-gradient-to-b from-[#050D1C] via-[#07142B] to-[#050D1C]"
        >
            <div className="max-w-7xl mx-auto px-6 md:px-12">
                <div className="reveal max-w-3xl">
                    <span className="eyebrow">{t("why.eyebrow")}</span>
                    <h2 className="font-serif-display text-white text-4xl sm:text-5xl lg:text-6xl mt-6 leading-[1.05]">
                        {t("why.title_a")} <em className="not-italic text-[#C9A96E]">{t("why.title_highlight")}</em>
                    </h2>
                </div>

                <div className="mt-16 grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-5">
                    {pillars.map((p, i) => {
                        const Icon = ICONS[i] || Sparkles;
                        return (
                            <div
                                key={p.title}
                                data-testid={`pillar-${i}`}
                                className="reveal glass-card p-8 md:p-10 group"
                                style={{ transitionDelay: `${i * 60}ms` }}
                            >
                                <Icon
                                    size={30}
                                    strokeWidth={1.2}
                                    className="text-[#C9A96E] transition-transform duration-500 group-hover:-translate-y-1"
                                />
                                <h3 className="mt-6 font-serif-display text-white text-2xl">{p.title}</h3>
                                <p className="mt-3 text-slate-400 text-sm leading-relaxed">{p.desc}</p>
                                <div className="mt-6 h-px w-8 bg-[#C9A96E]/50 group-hover:w-16 transition-all duration-500" />
                            </div>
                        );
                    })}
                </div>
            </div>
        </section>
    );
}
